/* eslint-disable import/prefer-default-export */
export const expressCheckoutConfigs = [
        {
            namespace: 'express',
            availableProductIds: [
                // -- Groeimarkten
                3575
            ],
            selectedProductIds: [3575],
            masterCombiIds: [3575],
            showMonthlySavings: true,
            loadingProducts: true,
            stepLabels: ['Looptijd', 'Gegevens', 'Betaling'],
            debug: true,
            showModal: 1,
        },
];
